<ng-container *ngIf="state$ | async as state">
    <ng-container *ngIf="state | isPageReady">
        <app-page-component-identifier *ngFor="let component of state.data.components"
                                       [data]="component"
                                       [firstComponent]="state.data.components[0]"
        ></app-page-component-identifier>
    </ng-container>

    <ng-container *ngIf="state.status === 'not-found'">
        <app-grid>
            <app-cell mobile="0:12">
                <div class="page-not-found">
                    <h1>{{ 'common.page-not-found' | translate }}</h1>

                    <app-button size="normal"
                                theme="dark"
                                layout="label-only"
                                type="link"
                                link="/"
                    >
                        {{ 'auth.go-to-home' | translate }}
                    </app-button>
                </div>
            </app-cell>
        </app-grid>
    </ng-container>

    <ng-container *ngIf="state.status === 'loading'">
        <app-page-spinner></app-page-spinner>
    </ng-container>
</ng-container>
